import { FC } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Icon from 'src/view/components/Controls/Icon/Icon';

interface IProps {
  fileName?: string;
  loading: boolean;
  onReset: () => void;
  formDataAppend: () => void;
}

const UploadControls: FC<IProps> = (props: IProps): JSX.Element | null => {
  if (!props.fileName) return null;

  return (
    <div className="upload__button-container">
      <Button onClick={props.onReset} loading={props.loading} className="upload__button mb-2">
        <Icon name={Icons.Reset} size={18} color={theme.colors.white} />
      </Button>
      <Button onClick={props.formDataAppend} loading={props.loading} className="upload__button">
        <Icon name={Icons.Ok} size={14} color={theme.colors.white} />
      </Button>
    </div>
  );
};

export default UploadControls;
